export const DEFAULT_OFFSET_IN_PX = 200;
